import PilantropoSC from '../../assets/images/content/pilantropo_sc.jpg';
import HappyPigsSC from '../../assets/images/content/happypigs_sc.png';
import NexusSC from '../../assets/images/content/nexus_sc.png';
import SitiounoSc from '../../assets/images/content/sitiouno_sc.jpg';
import SVSc from '../../assets/images/content/sv_sc.png';
import LinecareSc from '../../assets/images/content/linecare_sc.png';
import iProtechSc from '../../assets/images/content/iprotech_sc.png';
import PokedexSc from '../../assets/images/content/pokedex_sc.png';

const projects = [
  {
    title: 'Pilantropo Website',
    url: 'pilantropo.com',
    techs: ['React', 'Django', 'CSS3 | Scss', 'Bootstrap'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: PilantropoSC
  },
  {
    title: 'Pokedex Side Project',
    url: 'neyoojeey-pokedex.netlify.com/',
    techs: ['React', 'PokeAPI', 'CSS3 | Scss', 'Bootstrap'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: PokedexSc
  },
  {
    title: 'Linecare Website',
    url: 'linecare.net',
    techs: ['React', 'CSS3 | Scss', 'Bootstrap'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: LinecareSc
  },
  {
    title: 'Sitio Uno Website',
    url: 'sitiouno.com.ph',
    techs: [
      'HTML5',
      'Bootstrap',
      'CSS3 | Scss',
      'JavaScript',
      'Wordpress',
      'Twig'
    ],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: SitiounoSc
  },
  {
    title: 'iProtech Website',
    url: 'iprotech.tech',
    techs: ['HTML5', 'Bootstrap', 'CSS3 | Scss', 'JavaScript', 'Wordpress'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: iProtechSc
  },
  {
    title: 'Happy Pigs Website',
    url: 'thehappypigs.com',
    techs: ['HTML5', 'Bootstrap', 'CSS3 | Scss', 'JavaScript'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: HappyPigsSC
  },
  {
    title: 'NexUs Website',
    url: 'nexus.springvalley.tech',
    techs: ['HTML5', 'Bootstrap', 'CSS3 | Scss', 'JavaScript', 'Webpack'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: NexusSC
  },
  {
    title: 'Spring Valley Website',
    url: 'springvalley.tech',
    techs: [
      'HTML5',
      'Bootstrap',
      'GulpJs',
      'CSS3 | Scss',
      'JavaScript',
      'Wordpress'
    ],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur animi ut nam ea necessitatibus maiores nesciunt expedita similique vero ad debitis dolorem provident quis eaque modi veniam dolore, dolorum atque?',
    image: SVSc
  }
];

export { projects };
